module.exports = __webpack_public_path__ + "img/venus29.464000f9.png";